import { FC } from 'react';
import { useIntercom } from 'react-use-intercom';

import Button from 'components/_core/Button';
import Callout from 'components/_core/Callout';

import locales from './locales';

const ReferralNoCodeCallout: FC = () => {
  const { show } = useIntercom();

  return (
    <Callout hideIcon={true} marginBottom={32} variant="info">
      {locales.text}
      <Button onClick={() => show()} variant="inline-secondary">
        {locales.button}
      </Button>
    </Callout>
  );
};

export default ReferralNoCodeCallout;
